module.exports = __webpack_public_path__ + "static/media/20170501-DSC02549-8_Small.a4d46f78.jpg";